<template>
  <div class="soluction">
    <div class="banner_pc" @click="getHouse">
      <img src="https://www.bjecpower.com/img/gw/pb02.png" alt="" />
    </div>
    <div class="banner_mo">
      <img src="https://www.bjecpower.com/img/gw/mb02.png" alt="" />
    </div>
    <!-- 行业痛点 -->
    <div class="solu_header">
      <div class="home_con">
        <div class="title_flex">
          <p class="solu_title">行业痛点</p>
          <p class="solu_title_er">
            结合目前行业动向,电动汽车充电业务在市场上所遭遇的痛点
          </p>
        </div>
        <div class="header_leftzong">
          <div class="header_left">
            <!-- 背景图 -->
            <div class="bg_title zz">
              <img src="@/assets/mobile/1.png" alt="" />
              <span>终端质量</span>
            </div>
            <p>
              <span
                >新能源崛起的大背景下，为快速投入市场使用，部分设备质量问题无法保障。</span
              >
              <span
                >设备厂商提供的运营平台功能单一，无法满足运营端基本的运营诉求。</span
              >
            </p>
            <p></p>
          </div>
          <div class="header_left left_aa">
            <!-- 背景图 -->
            <div class="bg_title xx">
              <img src="@/assets/mobile/3.png" alt="" />
              <span>运维困难</span>
            </div>
            <p>
              <span
                >新能源市场在经过大规模"跑马圈地"的模式下，后期的基本运维保障成为诸多运营商的难题。</span
              >
              <span class="span_no"
                >因此市场常见的"僵尸桩"、"垃圾站"屡见不鲜。</span
              >
            </p>
          </div>
          <div class="header_left left_aa">
            <!-- 背景图 -->
            <div class="bg_title cc">
              <img src="@/assets/mobile/3.png" alt="" />
              <span>入口繁杂</span>
            </div>
            <p>
              <span
                >新能源电站增量可观，但品牌多样化，导致电站越多用户充电越难。</span
              >
              <span>用户需下载不同软件才能满足多点位充电。</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 聚能一站式方案展示 -->
    <div class="juneng">
      <div class="show_con">
        <div class="home_con">
          <div class="title_flex">
            <p class="solu_title">聚能一站式方案展示</p>
          </div>
          <div class="hh_title">
            <img src="@/assets/solu/hh.png" alt="" />
            <p class="sass">SaaS平台</p>
          </div>
        </div>
        <div class="show_imgbg">
          <div class="home_con" id="show_content">
            <div class="swiper_mobg">
              <div class="swiper_pc">
                <div class="swiper-container swiper-no-swiping">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide">
                      <ul>
                        <li><img src="@/assets/solu/hou1.png" alt="" /></li>
                      </ul>
                    </div>
                    <div class="swiper-slide">
                      <ul>
                        <li><img src="@/assets/solu/hou2.png" alt="" /></li>
                      </ul>
                    </div>
                    <div class="swiper-slide">
                      <ul>
                        <li><img src="@/assets/solu/hou3.png" alt="" /></li>
                      </ul>
                    </div>
                    <div class="swiper-slide">
                      <ul>
                        <li><img src="@/assets/solu/hou4.png" alt="" /></li>
                      </ul>
                    </div>
                  </div>

                  <div class="swiper-pagination"></div>
                </div>
              </div>
            </div>

            <div class="show_right sassttt">
              <p class="show_title">SaaS平台</p>
              <div class="right_top top_aa">
                <img src="@/assets/solu/dui.png" alt="" />
                <span>多种启动充电方式</span>
              </div>
              <span class="show_text"
                >支持手机扫码、刷卡、即插即充等多种启动方式，无需下载。</span
              >

              <div class="right_top">
                <img src="@/assets/solu/dui.png" alt="" />
                <span>支持多种电站运营方式</span>
              </div>
              <span class="show_text"
                >支持加盟、代运营、个人桩运营等多种运营模式。</span
              >

              <div class="right_top">
                <img src="@/assets/solu/dui.png" alt="" />
                <span>互联互通</span>
              </div>
              <span class="show_text"
                >支持与政府监管平台、企业自有平台及行业相关平台进行数据互联互通。同时具备接入聚能平台运营商授权互联互通能力，帮助企业完成一键互联。</span
              >

              <div class="right_top">
                <img src="@/assets/solu/dui.png" alt="" />
                <span>灵活的平台架构</span>
              </div>
              <span class="show_text textpa"
                >支持外部的分级运营，支持内部分区域运营，灵活搭配权限架构。</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 硬件支撑 -->
    <div class="yingjian">
      <div class="home_con">
        <div class="hh_title tit_aa">
          <img src="@/assets/solu/hh.png" alt="" />
          <p>硬件支撑</p>
        </div>
        <div class="hard">
          <div class="hard_a hard_aa">
            <div class="hard_bg" ref="hard_bg0">
              <img
                class="hard_bg_img"
                src="https://www.bjecpower.com/camera/company/dy.png"
                alt=""
              />
            </div>
            <div class="hard_a_out" ref="hard_bg_out0" @mouseover="toDetail(0)" @mouseout="out(0)">
              <img @click="out(0)" src="@/assets/b_2.png" alt="">
            </div>
            <div class="hard_index">
              <p class="hard_tit">高端智能直流终端</p>
              <p class="hard_tit_ti">
                大能效,适配多场景充电需求，15kW-150kW多种功率配置方案，满足客户定制化充电需求 
              </p>
              <div class="hard_top">
                <img src="@/assets/solu/dui.png" alt="" />
                <span>安全可靠</span>
              </div>
              <span class="hard_con"
                >CMS主动方案、柔性充电，充电安全及电池寿命同时保障
                单双枪定制化配置，满足用户不同充电需求。</span
              >
              <div class="hard_btn">
                <p @click="toDetail(0)">查看参数</p>
                <!-- <img src="" alt="" /> -->
              </div>
            </div>
          </div>

          <div class="hard_a hard_bb">
            <div class="hard_bg" ref="hard_bg1">
              <img
                @click.stop="out(1)"
                class="hard_bg_img"
                src="https://www.bjecpower.com/camera/company/gl.png"
                alt=""
              />
            </div>
            <div class="hard_a_out" ref="hard_bg_out1" @mouseover="toDetail(1)" @mouseout="out(1)">
              <img @click="out(1)" src="@/assets/b_2.png" alt="">
            </div>
            <div class="hard_index">
              <p class="hard_tit">高端智能交流终端</p>
              <p class="hard_tit_ti">
                绿色能源,国内首款支持“碳中和”的充电终端,目前绿电交易已占平台总交易的10%,对于企业宣传极具说服力
              </p>
              <div class="hard_top">
                <img src="@/assets/solu/dui.png" alt="" />
                <span>多形态颜值终端</span>
              </div>
              <span class="hard_con"
                >精细化服务态度，从颜值到质量严格把关，基于运营商个性化需求自动适配充电终端颜值形态。</span
              >
              <div class="hard_btn">
                <p @click="toDetail(1)">查看参数</p>
                <!-- <img src="" alt="" /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 运维服务 -->
    <div class="yunwei">
      <div class="show_con" style="height: 753px">
        <div class="home_con">
          <div class="hh_title tit_aa">
            <img src="@/assets/solu/hh.png" alt="" />
            <p>运维服务</p>
          </div>

          <div class="server_con">
            <img src="@/assets/solu/ca.png" alt="" />
            <div>
              <p>迭代支撑</p>
              <span
                >聚能平台服务标准为“以客户为主导的迭代流程”，周期性系统自检及客户周期性回访，保证系统健康度的同时，对客户使用问题实时收集，迭代依据来自于用户需求，真正做到“以客户为中心的产品体验流程”。</span
              >
            </div>
          </div>

          <img
            src="@/assets/solu/biao1.png"
            alt=""
            style="width: 100%; height: 108px; padding: 37px 0px 68px 0px"
          />

          <div class="server_con">
            <img src="@/assets/solu/cb.png" alt="" />
            <div>
              <p>客服</p>
              <span
                >客服专线7*24蹲守服务，专业培训后客服专员具备拆分问题定向的能力，拆分后问题精准分发到线上支持与线下运维负责团队，真正实现第一时间/快速解决问题。</span
              >
            </div>
          </div>

          <img
            src="@/assets/solu/biao.png"
            alt=""
            style="width: 100%; height: 108px; padding: 37px 0px 0px 0px"
          />
        </div>
      </div>
    </div>

    <!-- 移动端运维服务 -->
    <div class="yunwei_mo">
      <div class="show_con" style="height: 366px">
        <div class="home_con">
          <div class="hh_title tit_aa" style="margin-top: 49px">
            <img src="@/assets/solu/hh.png" alt="" />
            <p>运维服务</p>
          </div>

          <div class="server_con_mo">
            <div>
              <img src="@/assets/mobile/ca.png" alt="" />
              <p>迭代支撑</p>
            </div>

            <span
              >聚能平台服务标准为“以客户为主导的迭代流程”，周期性系统自检及客户周期性回访，保证系统健康度的同时，对客户使用问题实时收集，迭代依据来自于用户需求，真正做到“以客户为中心的产品体验流程”。</span
            >
          </div>

          <img
            src="@/assets/mobile/biao1.png"
            alt=""
            style="width: 329px; height: 38px; margin-top: 16px"
          />

          <div class="server_con_mo">
            <div>
              <img src="@/assets/mobile/cb.png" alt="" />
              <p>客服</p>
            </div>

            <span
              >客服专线7*24蹲守服务，专业培训后客服专员具备拆分问题定向的能力，拆分后问题精准分发到线上支持与线下运维负责团队，真正实现第一时间/快速解决问题。</span
            >
          </div>

          <img
            src="@/assets/mobile/biao2.png"
            alt=""
            style="width: 329px; height: 38px; margin-top: 16px"
          />
        </div>
      </div>
    </div>

    <!-- “有源”+“无源”多场景充电服务体系 -->
    <div class="youwu">
      <div class="home_con">
        <div class="hh_title tit_bb">
          <img src="@/assets/solu/hh.png" alt="" />
          <p>"有源"+ "无源" 多场景充电服务体系</p>
        </div>
        <div class="you_con" v-if="!youFlag">
          <div class="show_right" style="margin: 0px; width: 44%">
            <p class="show_title">"有源"服务</p>
            <div class="right_top">
              <img src="@/assets/solu/dui.png" alt="" />
              <span>特点</span>
            </div>
            <span class="show_text"
              >车位监控设备、即插即充、现场运维值守、移动充电车值守。</span
            >
            <div class="right_top">
              <img src="@/assets/solu/dui.png" alt="" />
              <span>场景</span>
            </div>
            <span class="show_text"
              >投资空港、铁路、物流园区、城市卫星城等地段专用场站，地铁、商场大型社区等通用场站。</span
            >

            <div class="right_top">
              <img src="@/assets/solu/dui.png" alt="" />
              <span>系统</span>
            </div>
            <span class="show_text"
              >单站配有智慧能量管理系统，整体使用率提高。场站外电源独立包装，抢占电源优势。</span
            >
            <div class="ri_img" style="display:flex;justify-content:flex-end;">
              <img
                style="
                  width: 89px;
                  height: 89px;
                  
                "
                src="@/assets/ln.png"
                alt=""
              />
              <img
                v-if="!rightFlag"
                @click="next"
                style="width: 89px; height: 89px"
                src="@/assets/ry.png"
                class="right_cl"
                alt=""
              />
              <img
                v-else
                style="width: 89px; height: 89px"
                src="@/assets/solu/rl.png"
                alt=""
              />
            </div>
          </div>

          <div class="you_img you"></div>
        </div>

        <div class="you_con" v-if="showFlag">
          <div class="show_right" style="width: 44%; margin: 0px">
            <p class="show_title">"无源"服务</p>
            <div class="right_top">
              <img src="@/assets/solu/dui.png" alt="" />
              <span>特点</span>
            </div>
            <span class="show_text"
              >车位监控设备、即插即充、现场运维值守、移动充电车值守。</span
            >
            <div class="right_top">
              <img src="@/assets/solu/dui.png" alt="" />
              <span>场景</span>
            </div>
            <span class="show_text"
              >投资空港、铁路、物流园区、城市卫星城等地段专用场站，地铁、商场大型社区等通用场站。</span
            >

            <div class="right_top">
              <img src="@/assets/solu/dui.png" alt="" />
              <span>系统</span>
            </div>
            <span class="show_text"
              >单站配有智慧能量管理系统，整体使用率提高。场站外电源独立包装，抢占电源优势。</span
            >
            <div class="ri_img" style="display:flex;justify-content:flex-end;">
              <img
                v-if="!backY"
                @click="backFlag"
                style="
                  width: 89px;
                  height: 89px;
                "
                src="@/assets/ly.png"
                alt=""
              />

              <img
                style="width: 89px; height: 89px"
                src="@/assets/ee.png"
                alt=""
              />
            </div>
          </div>

          <div class="you_img wu"></div>
        </div>

        <div class="you_canmo">
          <div v-if="!youFlag">
            <div class="you_img you"></div>
            <div
              class="show_right right_mo"
              style=" margin-top: 0px;height:auto;padding-bottom:32px;"
            >
              <p class="show_title title_mo">"有源"服务</p>
              <div class="right_top">
                <img src="@/assets/solu/dui.png" alt="" />
                <span>特点</span>
              </div>
              <span class="show_text"
                >车位监控设备、即插即充、现场运维值守、移动充电车值守。</span
              >
              <div class="right_top">
                <img src="@/assets/solu/dui.png" alt="" />
                <span>场景</span>
              </div>
              <span class="show_text"
                >投资空港、铁路、物流园区、城市卫星城等地段专用场站，地铁、商场大型社区等通用场站。</span
              >

              <div class="right_top">
                <img src="@/assets/solu/dui.png" alt="" />
                <span>系统</span>
              </div>
              <span class="show_text"
                >单站配有智慧能量管理系统，整体使用率提高。场站外电源独立包装，抢占电源优势。</span
              >
              <div class="ri_img">
                <img class="right_cl" src="@/assets/mobile/ln.png" alt="" />
                <img
                  v-if="!rightFlag"
                  @click="next"
                  style="position: absolute; left:124%"
                  src="@/assets/mobile/ry.png"
                  class="right_cl"
                  alt=""
                />
                <img
                  v-else
                  style="position: absolute; left:124%"
                  class="right_cl"
                  src="@/assets/solu/rn.png"
                  alt=""
                />
              </div>
            </div>
          </div>

          <div v-if="showFlag">
            <div class="you_img wu"></div>
            <div
              class="show_right right_mo"
              style=" margin-top: 0px;height:auto;padding-bottom:32px;"
            >
              <p class="show_title title_mo">"无源"服务</p>
              <div class="right_top">
                <img src="@/assets/solu/dui.png" alt="" />
                <span>特点</span>
              </div>
              <span class="show_text"
                >车位监控设备、即插即充、现场运维值守、移动充电车值守。</span
              >
              <div class="right_top">
                <img src="@/assets/solu/dui.png" alt="" />
                <span>场景</span>
              </div>
              <span class="show_text"
                >投资空港、铁路、物流园区、城市卫星城等地段专用场站，地铁、商场大型社区等通用场站。</span
              >

              <div class="right_top">
                <img src="@/assets/solu/dui.png" alt="" />
                <span>系统</span>
              </div>
              <span class="show_text" style="padding-bottom:32px;"
                >单站配有智慧能量管理系统，整体使用率提高。场站外电源独立包装，抢占电源优势。</span
              >
              <div class="ri_img">
                <img
                  @click="backFlag"
                  class="right_cl"
                  src="@/assets/mobile/ly.png"
                  alt=""
                />
                <img
                  style="position: absolute; left:124%"
                  class="right_cl"
                  src="@/assets/mobile/rn.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--应用场景  -->
    <div class="changj">
      <div class="show_con chang_aa">
        <div class="home_con">
          <div class="title_flex changyi">
            <p class="solu_title">应用场景</p>
            <p class="solu_title_er">具备完善的线下运营能力，有丰富的客户资源及开发维护经验。</p>
          </div>

          <!-- 背景图片 -->
          <ul class="appli">
            <li>
              <div class="app_nor">
                <img src="@/assets/solu/a1.png" alt="" />
                <p class="appnor_tit">酒店</p>
              </div>
            </li>
            <li style="margin-left: 48px">
              <div class="app_nor">
                <img src="@/assets/solu/30.png" alt="" />
                <p class="appnor_tit">物流园区</p>
              </div>
            </li>
            <li style="margin-left: 48px">
              <div class="app_nor">
                <img src="@/assets/solu/c1.png" alt="" />
                <p class="appnor_tit">社会场站</p>
              </div>
            </li>
            <li style="margin-left: 48px">
              <div class="app_nor">
                <img src="@/assets/solu/vip.png" alt="" />
                <p class="appnor_tit">VIP上门服务</p>
              </div>
            </li>
          </ul>

          <!-- 移动端 背景图片-->
          <ul class="appli_mo">
            <li>酒店</li>
            <li>物流园区</li>
            <li>社会场站</li>
            <li>VIP上门服务</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 回到顶部 -->
    <div class="home_pos" v-if="top">
      <div class="father">
        <ul class="son">
          <li>
            <img src="@/assets/solu/111.png" alt="" />
            <div>
              <p>咨询人</p>
              <p>刘经理</p>
            </div>
          </li>
          <li>
            <img src="@/assets/solu/222.png" alt="" />
            <div>
              <p>岗位</p>
              <p>市场经理</p>
            </div>
          </li>
          <li>
            <img src="@/assets/solu/333.png" alt="" />
            <div>
              <p>电话</p>
              <p>17710505631</p>
            </div>
          </li>
          <li>
            <img src="@/assets/solu/44.png" alt="" />
            <div>
              <p>邮箱</p>
              <p>hrzl@ec-power.cn</p>
            </div>
          </li>
          <li>
            <img src="@/assets/solu/55.png" alt="" />
            <div>
              <p>微信</p>
              <p>hezlf_ecpower</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="father_we">
        <div class="son_we">
          <img src="@/assets/pc/er.png" alt="" />
        </div>
      </div>

      <div @mouseover="gohover" v-if="!goFlag">
        <img src="@/assets/pc/goa.png" class="goimg" alt="" />
      </div>
      <div @click="backtop" @mouseout="goOut" v-else>
        <img src="@/assets/pc/gob.png" class="goimg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      youFlag: false,
      showFlag: false,
      rightFlag: false,
      backY: false,

      goFlag: false,
      top: false,
    };
  },
  mounted() {
    var THIS = this;
    window.addEventListener("scroll", function () {
      //监听滚动
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;

      if (scrollTop >= 500) {
        //如果当前滚动位置大于您的所需要达到的高度则显示置顶元素，反之不显示
        THIS.top = true;
      } else {
        THIS.top = false;
      }
    });

    let _this = this;
    let mySwiper = new Swiper(".swiper-container", {
      direction: "horizontal", // 垂直切换选项
      loop: true, // 循环模式选项
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
        // disableOnInteraction: false,
      },
      autoplay: true,
      delay: 5000,
      autoplayDisableOnInteraction: false,
      pagination: {
        el: ".swiper-pagination",
      },
    });
  },
  methods: {
    getHouse() {
      this.$bus.$emit("click");
    },
    next() {
      this.rightFlag = true;
      this.youFlag = true;
      this.showFlag = true;
      this.backY = false;
    },
    backFlag() {
      this.backY = true;
      this.youFlag = false;
      this.showFlag = false;
      this.rightFlag = false;
    },
    toDetail(e) {
      this.$refs["hard_bg" + e].style.height = "100%";
      this.$refs["hard_bg" + e].style.opacity = "1";
      this.$refs['hard_bg_out' + e].style.display = 'block'
      setTimeout(()=>{
        this.$refs['hard_bg_out' + e].style.opacity = "1";
      })
      
    },
    out(e) {
      this.$refs["hard_bg" + e].style.height = "0";
      this.$refs["hard_bg" + e].style.opacity = "0";
      this.$refs['hard_bg_out' + e].style.display = 'none'
      this.$refs['hard_bg_out' + e].style.opacity = "0";
    },
    gohover() {
      this.goFlag = true;
    },
    goOut() {
      this.goFlag = false;
    },
    gohover() {
      this.goFlag = true;
    },

    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
  },
};
</script>


<style>
#show_content .swiper-container {
  margin: 0px 25px;
}
#show_content
  .swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  width: 30px;
  height: 3px;
  background: #0084ff;
  border-radius: 0;
}

#show_content .swiper-pagination-bullet-active {
  background: #e7ecf3;
  width: 30px !important;
}
#show_content .swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 13px;
}
@media screen and (max-width: 768px) {
  #show_content .swiper-container {
    margin: 0px 30px;
  }
  #show_content
    .swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    width: 14px;
    height: 3px;
    background: #0084ff;
    border-radius: 0;
  }

  #show_content .swiper-pagination-bullet-active {
    background: #fff;
    width: 14px !important;
  }
  #show_content .swiper-container-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    bottom: 8px;
    display: flex;
    justify-content: start;
    margin-left: 36%;
  }
}
</style>
<style scoped>

.sass {
  padding-bottom: 32px;
}
.solu_title_er {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #9ea5bb;
  line-height: 63px;
  margin-left: 16px;
}

.swiper_mobg {
  /* width:60%; */
}
.span_no {
  padding-top: 16px;
  margin-top: 16px;
}
.textpa{
  padding-bottom:30px;
}
.banner_pc {
  width: 100%;
  box-sizing: border-box;
}
.banner_pc img {
  max-width: 100%;
  width: 100%;
}
.right_cl {
  width: 49px;
  height: 49px;
}
.appli_mo,
.you_canmo,
.yunwei_mo,
.banner_mo {
  display: none;
}
.youwu {
  height: 640px;
}
/* .changj{
height: 502px;
} */
.btn {
  font-size: 20px;
  padding: 12px 30px;
  margin-top: 200px;
}
.yingjian {
  height: 889px;
}

.tit_aa {
  padding-top: 72px;
}
.tit_bb {
  margin-top: 72px;
}
.hard {
  display: flex;
}
.hard_a {
  width: 47.6%;
  height: 640px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border: 1px solid #e5e5e5;
  text-align: left;
  position: relative;
}
.hard_a .hard_bg {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0%;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: 1s;
  /* z-index: ; */
}
.hard_a .hard_a_out{
  width: 100%;
  height: 100%;
  z-index: 5;
  position: absolute;
  display: none;
  opacity: 0;
  transition: 3s;
}
.hard_a .hard_a_out > img{
  width: 25px;
  height: 15px;
  position: absolute;
  top: 27px;
  right: 27px;
}
.hard_bg:active .hard_bg_img {
  display: none;
}
.hard_a .hard_bg img {
  width: 100%;
  height: 100%;
}
.hard_index {
  padding-left: 32px;
}
.hard_aa {
  background-image: url("https://www.bjecpower.com/img/gw/cz.png");
}
.hard_bb {
  background-image: url("https://www.bjecpower.com/img/gw/cj.png");
  margin-left: 48px;
}

.hard_tit {
  font-size: 28px;
  margin: 40px 0px 24px 0px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #191c27;
  line-height: 42px;
}
.hard_tit_ti {
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 24px;
  margin-right: 23px;
}
.hard_top {
  display: flex;
  align-items: center;
  margin: 24px 0px 16px 0px;
}
.hard_top img {
  width: 13px;
  height: 9px;
}
.hard_top span {
  display: block;
  margin-left: 4px;
  font-size: 18px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #191c27;
  line-height: 27px;
}
.hard_con {
  display: block;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #9ea5bb;
  line-height: 24px;
  margin-right: 23px;
}
.hard_btn {
  width: 150px;
  height: 40px;
  border: 1px solid #0084ff;
  margin-top: 78px;
  cursor: pointer;
}
.hard_btn :hover {
  background: #0084ff;
  color: #ffffff;
}
.hard_btn :active {
  background: #016ed3;
  color: #ffffff;
}
.hard_btn p {
  font-size: 18px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #0084ff;
  line-height: 40px;
  text-align: center;
}
.hard_btn img {
  width: 8px;
  height: 14px;
}

.you_con {
  display: flex;
}
.you_img {
  width: 560px;
  height: 420px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* margin-left: 51px; */
}
.you {
  background-image: url("https://www.bjecpower.com/img/gw/you.png");
}
.wu {
  background-image: url("https://www.bjecpower.com/img/gw/wu.png");
}
.ri_img {
  /* width:417px; */
  /* display: flex; */
  justify-content: end;
  margin-top: 60px;
}

.home_pos {
  position: fixed;
  right: 16px;
  bottom: 6%;
  width: 100px;
}

.home_pos .goimg {
  width: 115px;
  height: 115px;
  cursor: pointer;
}

.father {
  width: 99px;
  height: 112px;
  background-image: url("https://www.bjecpower.com/img/gw/zx.png");
  background-size: 100% 100%;
  cursor: pointer;
  position: relative;
}

.son {
  height: 0px;
  width: 0px;
  /* max-width: 0px; */
  position: absolute;
  top: 0;
  right: 95%;
  /* 收回的时候快一点 */
  transition: width 200ms;
  overflow: hidden;
}
.father:hover .son {
  /* 将transition写在;hover中，很是巧妙 */
  /* 伸展的时候慢一点 */
  width: 233px;
  /* max-width: 233px; */
  height: 318px;
  background: #ffffff;
  box-shadow: 0px 0px 16px 0px rgba(0, 52, 144, 0.12);
  transition: width 800ms;
  /* animation: son 0.5s linear; */
}
.father_we {
  width: 99px;
  height: 112px;
  background-image: url("https://www.bjecpower.com/img/gw/wx.png");
  background-size: 100% 100%;
  cursor: pointer;
  position: relative;
}

.son_we {
  height: 214px;
  width: 190px;
  /* max-width: 0px; */
  position: absolute;
  top: 0;
  right: 95%;
  /* 收回的时候快一点 */
  /* transition: width 200ms; */
  overflow: hidden;
}
.son_we img {
  height: 214;
  width: 190px;
  position: absolute;
  top: 0;
  right: -100%;
}
.son li {
  display: flex;
}
.son li img {
  width: 20px;
  height: 20px;
  margin: 24px 0px 0px 32px;
}
.son li div {
  margin-left: 12px;
  margin-top: 18px;
  text-align: left;
}
.son li div p:nth-child(1) {
  font-size: 14px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #5a6073;
  line-height: 21px;
}
.son li div p:nth-child(2) {
  font-size: 12px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 18px;
  margin-top: 3px;
}
/* 交集选择器，所以父子关系的div盒子才可以 */
.father_we:hover .son_we img {
  /* 将transition写在;hover中，很是巧妙 */
  /* 伸展的时候慢一点 */
  width: 190px;
  height: 214px;
  transition: 800ms;
  right: 0;
}
.son ul li {
  display: flex;
}

.solu_header {
  width: 100%;
  height: 456px;
  background: #fff;
}
.swiper_pc {
  width: 522px;
  margin-top: 85px;
  
}
.swiper_pc .swiper-slide ul li {
  width: 100%;
  height: 356px;
}
.swiper_pc .swiper-slide ul li img {
  width: 100%;
  height: 100%;
}
.bg_title {
  width: 100%;
  height: 86px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bg_title img {
  display: none;
}
.zz {
  background-image: url("https://www.bjecpower.com/img/gw/3.png");
}
.xx {
  background-image: url("https://www.bjecpower.com/img/gw/4.png");
}
.cc {
  background-image: url("https://www.bjecpower.com/img/gw/5.png");
}
.bg_title span {
  display: block;
  font-size: 22px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #ffffff;
  line-height: 86px;
  text-align: left;
  padding-left: 24px;
}

.header_left {
  width: 32%;
  /* width: 317px; */
  height: 265px;
  text-align: left;
}
.chang_aa {
  height: 515px !important;
}
.show_con {
  width: 100%;
  /* height: 815px; */
  height: 853px;
  background: #f3f5fc;
  padding-bottom: 67px;
}
.show_right {
  text-align: left;
  margin-top: 110px;
  margin-left: 40px;
}
.sassttt{
  margin-top:85px!important;
}
.show_title {
  font-size: 28px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #191c27;
  line-height: 42px;
}
.show_right .right_top img {
  width: 15px;
  height: 12px;
}
.right_top {
  margin-top: 24px;
  display: flex;
  align-items: center;
}
.show_right span:nth-child(2) {
  display: block;
  margin-left: 8px;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #191c27;
  line-height: 15px;
}
.show_text {
  display: block;
  width: 389px;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 21px;
  margin-top: 10px;
}
#show_content {
  display: flex;
}
.show_imgbg {
  width: 100%;
  /* height:740px; */
  background-image: url("https://www.bjecpower.com/img/gw/b04.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.server_con {
  display: flex;
}
.server_con img {
  width: 70px;
  height: 75px;
}
.server_con div {
  margin-left: 18px;
  text-align: left;
}
.server_con p {
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #191c27;
  line-height: 30px;
}
.server_con span {
  display: block;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 21px;
  margin-top: 16px;
}
.appli {
  display: flex;
  text-align: left;
}
.appli li img {
  width: 43px;
  height: 40px;
}
.appli li {
  width: 23.2%;
  height: 310px;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  position: relative;
  cursor: pointer;
}
.appli li:nth-child(1) {
  background-image: url("https://www.bjecpower.com/img/gw/a.png");
}
.appli li:nth-child(2) {
  background-image: url("https://www.bjecpower.com/img/gw/b.png");
}
.appli li:nth-child(3) {
  background-image: url("https://www.bjecpower.com/img/gw/c.png");
}
.appli li:nth-child(4) {
  background-image: url("https://www.bjecpower.com/img/gw/d.png");
}
.appnor_con {
  font-size: 16px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #ffffff;
  line-height: 27px;
}
.app_nor {
  position: absolute;
  left: 24px;
  bottom: 24px;
}
.appnor_tit {
  font-size: 26px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #ffffff;
  line-height: 39px;
}


</style>

<style scoped>
@media screen and (max-width: 768px) {
  .textpa{
    padding-bottom: 0px;
  margin-bottom:30px;
}
  .changyi{
    padding-top:120px;
  }
  .sass {
    padding-bottom: 0px;
  }
  .sassttt {
    height:auto;
    margin-top:0px;
    margin-top:32px!important;
    padding-bottom:32px;
    box-shadow: 0px 2px 11px 0px rgba(158, 165, 187, 0.18);
    /* height: 391px; */
  }
  .solu_title_er {
    font-size: 12px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #9ea5bb;
    line-height: 11px;
    margin-left: 0px;
  }
  .hard_aa {
    background-image: url("https://www.bjecpower.com/img/gw/dct.png");
  }
  .hard_bb {
    background-image: url("https://www.bjecpower.com/img/gw/bdb.png");
    margin-left: 48px;
  }
  .show_con {
    width: 100%;

    /* height: 779px; */
    height: 753px;
    background: #f3f5fc;
    padding-bottom: 67px;
  }
  .banner_pc {
    display: none;
  }
  .sass {
    font-size: 18px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #191c27;
    line-height: 18px;
  }
  .banner_mo {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }

  .banner_mo img {
    max-width: 100%;
    width: 100%;
  }
  .you_canmo {
    display: block;
    position: relative;
  }
  .ri_img {
    width:100%;
    display: flex;
    justify-content: space-around;
    position: absolute;
    
    top:4%;
    right:42%;
    
  }
  .ri_img img {
    width: 76px;
    height: 81px;
  }
  .ri_img:nth-child(1) {
    position: absolute;
    left: 300px;
  }
  .right_cl {
    width: 76px;
    height: 81px;
  }
  .yingjian {
    display: block;
  }
  .hard {
    display: block;
  }
  .hard_a {
    width: 91%;
    height: 394px;
    margin: 32px 15px 0px 15px;
  }
  .tit_aa {
    padding-top: 0px;
  }
  .swiper_pc {
    width: 100%;
    height: 203px;
    margin: 24px 0px 0px 0px;
    /* margin: 24px 30px 0px 30px; */
    /* background-image: url("https://www.bjecpower.com/img/gw/b01.png"); */
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
  }
  .swiper_mobg {
    width: 100%;
    height: 193px;
    background-image: url("https://www.bjecpower.com/img/gw/b01.png");
    background-size: 100% 100%;
  }
  .hard_a .hard_bg {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: 1s;
  }
  .hard_a .hard_bg img {
    width: 100%;
    height: 100%;
  }
  .hard_index {
    padding-left: 15px;
    margin-right: 34px;
  }

  .hard_tit {
    margin: 32px 0px 16px 0px;
    font-size: 20px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #191c27;
    line-height: 20px;
  }
  .hard_tit_ti {
    width: 102%;
    height: 58px;
    font-size: 14px;
    font-family: Helvetica;
    color: #5a6073;
    line-height: 21px;
  }
  .hard_top {
    display: flex;
    align-items: center;
    margin: 24px 0px 16px 0px;
  }
  .hard_top img {
    width: 13px;
    height: 9px;
  }
  .hard_top span {
    display: block;
    margin-left: 4px;
    font-size: 16px;
    font-family: Helvetica;
    color: #191c27;
    line-height: 19px;
  }
  .hard_con {
    width: 153px;
    display: block;
    font-size: 14px;
    font-family: Helvetica;
    color: #9ea5bb;
    line-height: 21px;
  }
  .hard_btn {
    width: 106%;
    height: 44px;
    border: 1px solid #0084ff;

    margin-top: 29px;
    cursor: pointer;
  }
  .hard_btn :hover {
    background: #0084ff;
    color: #ffffff;
  }
  .hard_btn :active {
    background: #016ed3;
    color: #ffffff;
  }
  .hard_btn p {
    font-size: 16px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #0084ff;
    line-height: 44px;
    text-align: center;
  }
  .hard_btn img {
    display: none;
  }

  .swiper_pc .swiper-slide ul li {
    width: 100%;
    height: 203px;
  }
  .swiper_pc .swiper-slide ul li img {
    width: 100%;
    height: 100%;
  }
  .yunwei_mo {
    display: block;
    margin-bottom: 49px;
  }
  .tit_aa {
    padding-top: 0px;
    margin-top: 24px;
  }

  .yunwei {
    display: none;
  }
  .changj {
    height: 520px;
    margin-top: 50px;
  }
  .you_con {
    display: none;
  }
  .right_mo .title_mo {
    display: block;
  }
  .you_img {
    width: 84.5%;
    height: 236px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin: 30px 30px 20px 30px;
  }
  .you {
    background-image: url("https://www.bjecpower.com/img/gw/you.png");
  }
  .wu {
    background-image: url("https://www.bjecpower.com/img/gw/wu.png");
  }
  .show_title {
    height: 65px;
    margin-right: 15px;
    border-bottom: 1px solid #e5e5e5;
    font-size: 18px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #191c27;
    line-height: 65px;
  }

  .appli {
    display: none;
  }
  .appli_mo {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin: 40px 0px 40px 6px;
  }
  .appli_mo li {
    width: 45%;
    /* width:168px; */
    margin: 0px 0px 9px 9px;
    height: 126px;
    background-image: url("https://www.bjecpower.com/img/gw/a.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;

    font-size: 20px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 126px;
  }
  .appli_mo li:nth-child(1) {
    background-image: url("https://www.bjecpower.com/img/gw/htl.png");
  }
  .appli_mo li:nth-child(2) {
    background-image: url("https://www.bjecpower.com/img/gw/tstn.png");
  }
  .appli_mo li:nth-child(3) {
    background-image: url("https://www.bjecpower.com/img/gw/sstn.png");
  }
  .appli_mo li:nth-child(4) {
    background-image: url("https://www.bjecpower.com/img/gw/sm.png");
  }
  .yunwei {
    display: none;
  }
  /* .yingjian {
    display: none;
  } */

  .server_con_mo div {
    display: flex;
    align-items: center;
    margin: 32px 0px 15px 15px;
  }
  .server_con_mo div img {
    width: 35px;
    height: 35px;
    margin: 0px 12px 0px 0px;
  }
  .server_con_mo div p {
    font-size: 18px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #191c27;
    line-height: 18px;
  }
  .server_con_mo span {
    font-size: 14px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #5a6073;
    line-height: 21px;
    margin: 0px 15px;
    text-align: left;
    display: block;
  }
  .solu_header {
    width: 100%;
    height: 0px;
    background: #fff;
  }
  .header_leftzong {
    display: block;
    padding-top: 10px;
  }
  .header_left {
    width: 100%;
    height: 136px;
    border: none;
  }
  .zz {
    background-image: none !important;
  }
  .xx {
    background-image: none !important;
  }
  .cc {
    background-image: none !important;
  }
  .bg_title {
    width: 100%;
    display: flex;
    align-items: center;
    height: 0px;
    margin: 32px 0px 17px 0px;
  }
  .bg_title img {
    display: block;
    width: 35px;
    height: 35px;
    margin-left: 12px;
  }
  .bg_title span {
    display: block;
    margin-left: -12px;
    font-size: 18px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #191c27 !important;
    line-height: 16px;
    text-align: left;
  }
  .juneng {
    margin-top: 600px;
  }
  .show_con {
    width: 100%;
    /* margin-top: 600px; */
    background: #fff;
  }
  #show_content {
    display: block;
  }
  .show_right {
    text-align: left;
    width: 89%;
    margin-top: 0px;
    margin-left: 15px;
    padding-left: 15px;
    /* height: 425px; */
    background: #ffffff;
    box-shadow: 0px 2px 11px 0px rgba(158, 165, 187, 0.18);
  }
  .show_title {
    display: none;
  }
  .show_right .right_top img {
    width: 13px;
    height: 9px;
  }
  .right_top {
    margin-top: 24px;
    display: flex;
    align-items: center;
  }
  .show_right span:nth-child(2) {
    display: block;
    font-size: 16px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #191c27;
    line-height: 15px;
  }
  .top_aa {
    padding-top: 24px;
  }
  .show_text {
    display: block;
    width: 86%;
    margin-top: 10px;
    font-size: 14px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #5a6073;
    line-height: 21px;
    margin-left: 23px;
  }
  .show_imgbg {
    width: 100%;
    height: 0px;
    background-image: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/solu/soluc.vue